import { trimText } from '../input_form/TagInput'

import { CampaignCategory, CampaignCostHandlingMethod } from '~/generated/graphql'

type CreateOfferAutoMessageProps = {
  category: CampaignCategory | null
  costHandlingMethod: CampaignCostHandlingMethod
}

type Condition = {
  text: string
  check: (input: CreateOfferAutoMessageProps) => boolean
}

export const createOfferAutoMessage = ({ category, costHandlingMethod }: CreateOfferAutoMessageProps) => {
  if (!category) return ''

  for (const condition of offerAutoMessageConditions) {
    const { text, check } = condition
    if (check({ category, costHandlingMethod })) return text
  }

  return ''
}

const offerAutoMessageConditions: Condition[] = [
  {
    text: trimText(`
        ご応募いただき誠にありがとうございます。
        当日のご来店を心よりお待ちしております。

        ご不明な点がございましたら、どうぞお気軽にご連絡くださいませ。
      `),
    check: ({ category, costHandlingMethod }) => {
      return category === CampaignCategory.Service && costHandlingMethod === CampaignCostHandlingMethod.ExpenseCampaign
    },
  },
  {
    text: trimText(`
        ご応募いただきありがとうございます。 

        ■日程調整について 来店を希望する日時を【提案日から3日以降の日程】で【3つ】ご提案ください。
        ※メッセージ上でのやり取りでは、日程確定となりません。 

        また、来店人数が応募時の同伴者数と異なる場合はこちらでお知らせください。
      `),
    check: ({ category, costHandlingMethod }) => {
      return category === CampaignCategory.Service && costHandlingMethod === CampaignCostHandlingMethod.NoChargeCampaign
    },
  },
  {
    text: trimText(`
      ご応募いただき誠にありがとうございます。
      「ご案内」にてご案内しております方法に従い、ご購入をお願いいたします。

      ご不明な点がございましたら、どうぞお気軽にご連絡くださいませ。
    `),
    check: ({ category, costHandlingMethod }) => {
      return category === CampaignCategory.Product && costHandlingMethod === CampaignCostHandlingMethod.ExpenseCampaign
    },
  },
  {
    text: trimText(`
      この度は弊社キャンペーンにご応募頂き誠にありがとうございます。

      ご登録のご住所宛てに商品をお送りいたしますので、到着までお待ちください。
      商品到着後、実際に使用していただき、1週間以内に投稿をお願い致します。
      商品について不明点等ございましたらお気軽にメッセージください。
    `),
    check: ({ category, costHandlingMethod }) => {
      return category === CampaignCategory.Product && costHandlingMethod === CampaignCostHandlingMethod.NoChargeCampaign
    },
  },
]
